/* eslint-disable react/jsx-pascal-case */

import React, { useMemo, useState, useEffect, useContext, useRef } from "react";
import { Button, Card, Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import { Alert, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import UserContext from "@context/User/UserContext";
import { asignarCertificacionMos, getCertificacionesMosByFolio } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import { getDatosSegundoUsuario } from "@helpers/httpRequests/httpRequestsUsuarios/estudiantes/httpRequestsEstudiantes";
import { AlertSimple, ModalSweetAlert } from "@components/general/Alertas/Alertas";
import { createCheckoutSession, getPriceCertificacionMosAdicional, getPriceCertificacionMosAdicionalExterna } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import Swal from "sweetalert2";
import stripe from "@helpers/stripe/stripe";
import { NotificationManager } from "react-notifications";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import getDateFromUnix from "@helpers/dates/getDateFromUnix/getDateFromUnix";
import { useTranslation } from "react-i18next";

const CircularProgressWithLabel = (props) => {
	return (
		<Box sx={{ position: "relative", display: "inline-flex" }}>
			<CircularProgress variant="determinate" {...props} />

			<Box
				sx={{
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
					position: "absolute",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}>
				<Typography variant="overline" component="div" color="text.secondary">
					{`${Math.round(props.value)}%`}
				</Typography>
			</Box>
		</Box>
	);
};

const CertificacionesAdquiridas = ({derechoExamen}) => {
	const { contextValue, setContextValue } = useContext(UserContext);

	const { usuarioLogeado } = contextValue;

	const { folioContrato, idCodigoRegion, rol, usuarioTitular, esSuscripcion } = usuarioLogeado;

	const {t} = useTranslation();

	const columnas = useMemo(() => [
		{
			id: "nombreCompleto",
			header: `${t("assignMOSCertification.historyTable.name")}`,
			accessorFn: (row) => `${row.nombreCompleto} ${row.apellidos}`,
		},
		{
			id: "tipoUsuario",
			header: `${t("assignMOSCertification.historyTable.certifiedBeneficiary")}`,
			accessorFn: (row) => {
				switch (row.tipoUsuario) {
					case 1:
						return "Usuario titular";
					case 2:
						return "Usuario secundario";

					case 3:
						return "Persona externa";

					default:
						break;
				}
			},
		},
	]);

	const [formValues, setFormValues] = useState({
		folioContrato,
		idPerfil: null,
		nombreCompleto: "",
		apellidos: "",
		tipoUsuario: 0,
		correoTitular: usuarioLogeado.correo,
		correoPersonaCertificacion: "",
		nombreCompletoTitular: `${usuarioLogeado.nombreCompleto} ${usuarioLogeado.apellidos}`,
		nombreTitular: usuarioLogeado.nombreCompleto,
		derechoMos: false,
	});

	const formButtonRef = useRef(null);

	const { nombreCompleto, apellidos, correoPersonaCertificacion } = formValues;

	const [certificacionesAsignadas, setCertificacionesAsignadas] = useState([]);

	const [cantidadCertificacionesMos, setCantidadCertificacionesMos] = useState([]);

	const [progresoUsoCertificaciones, setProgresoUsoCertificaciones] = useState(0);

	const [cantidadExamenesRealizados, setCantidadExamenesRealizados] = useState(0);

	const [cantidadCertificacionesAprobadas, setCantidadCertificacionesAprobadas] = useState(0);

	const [usuarioExterno, setUsuarioExterno] = useState(false);

	const [refetchData, setRefetchData] = useState(false);

	const [showLoader, setShowLoader] = useState(false);

	const consultarCertificaciones = async () => {
		try {
			let { cantidadCertificacionesMos: cantidadCertificacionesMosAux, certificacionesAsignadas: certificacionesAsignadasAux } = await getCertificacionesMosByFolio(folioContrato, idCodigoRegion);

			if (!Array.isArray(certificacionesAsignadasAux)) {
				certificacionesAsignadasAux = [certificacionesAsignadasAux];
			}

			const porcentajeCubierto = Math.floor((certificacionesAsignadasAux.length * 100) / cantidadCertificacionesMosAux);

			let examenesRealizados = 0;

			let examenesAprobados = 0;

			certificacionesAsignadasAux.forEach(({ intentos }) => {
				intentos.forEach(({ examenRealizado, aprobado }) => {
					if (examenRealizado) {
						examenesRealizados++;
					}

					if (aprobado) {
						examenesAprobados++;
					}
				});
			});

			setCertificacionesAsignadas(certificacionesAsignadasAux);

			setCantidadCertificacionesMos(cantidadCertificacionesMosAux);

			setProgresoUsoCertificaciones(porcentajeCubierto);

			setCantidadCertificacionesAprobadas(examenesAprobados);

			setCantidadExamenesRealizados(examenesRealizados);
		} catch (error) {
			console.log("Error al consultar las certificaciones MOS asignadas: ", error);
		}
	};

	useEffect(() => {
		if (certificacionesAsignadas.length === 0) {
			consultarCertificaciones();
		}
	}, []);

	const table = useMaterialReactTable({
		localization: MRT_Localization_ES,
		columns: columnas,
		data: certificacionesAsignadas,
		renderDetailPanel: ({ row }) => {
			const intentosCertificacion = row.original.intentos;

			return (
				<Container fluid>
					<Row>
						<Col>
							<TableContainer component={Paper}>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell className="text-center fw-bold text-primary">{t("assignMOSCertification.historyTable.attemptNumber")}</TableCell>

											<TableCell className="text-center fw-bold text-primary">{t("assignMOSCertification.historyTable.applicationDate")}</TableCell>

											<TableCell className="text-center fw-bold text-primary">{t("assignMOSCertification.historyTable.effectiveDate")}</TableCell>

											<TableCell className="text-center fw-bold text-primary">{t("assignMOSCertification.historyTable.examCompleted")}</TableCell>

											<TableCell className="text-center fw-bold text-primary">{t("assignMOSCertification.historyTable.testApproved")}</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{intentosCertificacion.map(({ numeroIntento, fechaSolicitud, fechaAgenda, examenRealizado, aprobado }, idx) => (
											<TableRow key={idx} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
												<TableCell component="th" className="text-center">
													# {numeroIntento}
												</TableCell>

												<TableCell component="th" className="text-center">
													{fechaSolicitud === null ? "No se ha solicitado la agenda" : getDateFromUnix(fechaSolicitud)}
												</TableCell>

												<TableCell component="th" className="text-center">
													{fechaAgenda === null ? "No se ha solicitado la agenda" : getDateFromUnix(fechaAgenda)}
												</TableCell>

												<TableCell component="th" className="text-center">
													{examenRealizado === 1 ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}
												</TableCell>

												<TableCell component="th" className="text-center">
													{aprobado === 1 ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</Col>
					</Row>
				</Container>
			);
		},
	});

	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		if (certificacionesAsignadas.length === cantidadCertificacionesMos) {
			return ModalSweetAlert({
				icon: "error",
				text: "Has alcanzado el límite de certificaciones adquiridas, para agregar otra persona, adquiere otra Certificación MOS",
			});
		}

		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleAgregarCertificacion = async (e) => {
		e.preventDefault();

		try {
			setShowLoader(true);

			await asignarCertificacionMos(formValues, idCodigoRegion);

			setRefetchData(true);

			setShowLoader(false);

			setOpen(false);
		} catch (error) {
			console.log("Error al asignar la certificacion: ", error);
		}
	};

	const handleSeleccionTipoUsuario = async ({ target }) => {
		const { value } = target;

		if (value === "") return;

		if (parseInt(value) > 0 && parseInt(value) < 3) {
			let datosPersona = {
				nombreCompleto: "",
				apellidos: "",
				correoPersonaCertificacion: "",
			};

			if (value === "1") {
				datosPersona = {
					nombreCompleto: usuarioLogeado.nombreCompleto,
					apellidos: usuarioLogeado.apellidos,
					correoPersonaCertificacion: formValues.correoTitular,
					idPerfil: usuarioLogeado.idPerfil,
					derechoMos: usuarioLogeado.derechoMos,
				};
			} else {
				if (!usuarioLogeado.segundoPerfil) {
					return NotificationManager.error("Aún no cuentas con un segundo usuario registrado");
				}

				const {
					data: { data: datosSegundoUsuario },
				} = await getDatosSegundoUsuario(usuarioLogeado.segundoPerfil);

				datosPersona = {
					nombreCompleto: datosSegundoUsuario.nombreCompleto,
					apellidos: datosSegundoUsuario.apellidos,
					correoPersonaCertificacion: datosSegundoUsuario.correo,
					idPerfil: datosSegundoUsuario.idPerfil,
					derechoMos: datosSegundoUsuario.derechoMos,
				};
			}

			setUsuarioExterno(false);

			setFormValues({
				...formValues,
				...datosPersona,
				tipoUsuario: parseInt(value),
			});
		} else {
			setFormValues({
				...formValues,
				nombreCompleto: "",
				apellidos: "",
				correoPersonaCertificacion: "",
				tipoUsuario: parseInt(value),
				idPerfil: null
			});

			setUsuarioExterno(true);
		}
	};

	const handleOnChange = ({ target }) => {
		setFormValues({
			...formValues,
			[target.name]: target.value,
		});
	};

	const handleComprarCertificacion = async () => {
		try {

			//TODO: Realizar las siguientes modificaciones para la validacion de ubicacion para compra de certificacion MOS
			//OBTENER IP DEL USUARIO AL PULSAR EL BOTON DE COMPRAR MAS
			//OBTENER LA UBICACION DE ESA IP PARA VALIDAR SI ES MEXICO O NO.
			//OBTENER EL PRECIO CORRESPONDIENTE DEPENDIENDO DEL RESULTADO..

			let id_precio;
			let currency;

			if(idCodigoRegion === 1){
				const { idPrecio } = await getPriceCertificacionMosAdicional();
				id_precio = idPrecio;
				currency = "mxn";
			}else {
				const { idPrecio } = await getPriceCertificacionMosAdicionalExterna();
				id_precio = idPrecio;
				currency = "usd";
				
			}


			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.compra.compraCertificacionMosRealizada}`,
				cancel_url: `${window.location.origin}${dashboardRoutesPaths.dashboard}`,
				line_items: [{ price: id_precio, quantity: 1 }],
				mode: "payment",
				currency,
				metadata: {
					folioContrato,
					pagoCertificacionMos: true,
				},
			};

			const checkoutSession = await createCheckoutSession(sessionData);

			const { isConfirmed } = await Swal.fire({
				title: t('leavingClick'),
				text: t('leavingClickMessage'),
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: t('ok'),
				cancelButtonText: t('Cancel'),
				confirmButtonColor: "#0d6efd",
				allowOutsideClick: false,
			});

			if (!isConfirmed) {
				return;
			}

			setContextValue({
				...contextValue,
				stripeSession: checkoutSession,
				idRegion: 1,
			});

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		

			
		} catch (error) {
			console.log("error al generar pago: ", error);
		}
	};

	useEffect(() => {
		if (!open) {
			setFormValues({
				...formValues,
				nombreCompleto: "",
				apellidos: "",
				correoPersonaCertificacion: "",
			});

			setUsuarioExterno(false);
		}
	}, [open]);

	useEffect(() => {
		if (refetchData) {
			consultarCertificaciones();

			setRefetchData(false);
		}
	}, [refetchData]);

	return (
		<>
			<Container fluid className="mt-3 mb-5">
				<Row className="mt-5 mb-5">
					<Col>
						{/* <Card body className="shadow mt-4"> */}
						<Typography variant="h4" gutterBottom>
							{t("acquiredCertifications.title")}
						</Typography>

						<Container className="mt-5" fluid>
							<Row className="align-items-center">
								<Col>
									<Card body className="shadow w-100 d-flex flex-row align-items-center" style={{minHeight: "250px"}}>
										<Typography variant="h5" gutterBottom className="text-center">
											{t("acquiredCertifications.acquiredCertifications")}
										</Typography>

										<div className="d-flex justify-content-center">
											<div className="d-flex align-items-center progreso-certificaciones-mos">
												<CircularProgressWithLabel value={progresoUsoCertificaciones} size={150} />

												<div className="d-flex flex-column ms-3">
													<Typography variant="subtitle1" gutterBottom>
														{certificacionesAsignadas.length} {t("assignMOSCertification.used")} /
													</Typography>

													<Typography variant="subtitle2" gutterBottom>
														{cantidadCertificacionesMos} {t("assignMOSCertification.acquired")}
													</Typography>

													{!esSuscripcion && (
														<Button variant="success" className="mt-1" onClick={handleComprarCertificacion}>
															{t('assignMOSCertification.earnMoreMOS')} <FaPlus />
														</Button>
													)}
												</div>
											</div>
										</div>
									</Card>
								</Col>

								<Col>
									<Card body className="shadow w-100 text-center d-flex flex-row align-items-center" style={{minHeight: "250px"}}>
										<Typography variant="h5" gutterBottom>
											{t("acquiredCertifications.testsPerformed")}
										</Typography>

										<Typography variant="h6" gutterBottom className="text-center">
											{cantidadExamenesRealizados} {t("assignMOSCertification.completed")}
										</Typography>
										<div className="d-flex align-items-center progreso-certificaciones-mos"></div>
									</Card>
								</Col>

								<Col>
									<Card body className="shadow w-100 text-center d-flex flex-row align-items-center" style={{minHeight: "250px"}}>
										<Typography variant="h5" gutterBottom>
											{t("acquiredCertifications.certificationsApproved")}
										</Typography>

										<Typography variant="h6" gutterBottom className="text-center">
											{cantidadCertificacionesAprobadas} {t("assignMOSCertification.approved")}
										</Typography>
										<div className="d-flex align-items-center progreso-certificaciones-mos"></div>
									</Card>
								</Col>
							</Row>
						</Container>
						{/* </Card> */}
					</Col>
				</Row>

				<Row className="mt-5 mb-3 d-flex flex-row justify-content-between align-items-center">
					{rol === "asesor" && (
						<Col className="col-12 mb-4">
							<Alert variant="outlined" severity="warning">
								Para asignar una certificación MOS a alguien de tu grupo empresarial dirigete al apartado de "Certificaciones mos" dentro del foro empresarial.
							</Alert>
						</Col>
					)}
					<Col xs="auto">
						<Typography variant="h4" gutterBottom>
							{t("acquiredCertifications.certificationsAwarded")}
						</Typography>
					</Col>

					<Col xs="auto">
						{certificacionesAsignadas.length !== cantidadCertificacionesMos ? (
							<Button variant="primary" onClick={handleOpen}>
								{t("assignMOSCertification.assign")}
							</Button>
						) : null}
					</Col>
				</Row>

				<Row>
					<Col>
						<MaterialReactTable table={table} />
					</Col>
				</Row>
			</Container>

			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>{t("assignMOSCertification.title")}</DialogTitle>
				<DialogContent>
					<DialogContentText>{t("assignMOSCertification.instructions")}</DialogContentText>

					<Form onSubmit={handleAgregarCertificacion} className="mt-3">
						<Form.Group className="mb-3">
							<FloatingLabel label={t("assignMOSCertification.chooseSomeone")}>
								<Form.Select onChange={handleSeleccionTipoUsuario}>
									<option value="">{t("assignMOSCertification.chooseAnOption")}</option>
									{!derechoExamen && (
										<option value="1">{t("assignMOSCertification.itsMe")}</option>
									)}
									{(rol === 'estudiante' && usuarioTitular) && (
										<option value="2">{t("assignMOSCertification.secondUser")}</option>
									)}
									<option value="3">{t("assignMOSCertification.externalPersonOption")}</option>
								</Form.Select>
							</FloatingLabel>
						</Form.Group>

						<Form.Group className="mb-3">
							<FloatingLabel label={t("assignMOSCertification.firstName")}>
								<Form.Control type="text" placeholder="Ingresa el nombre completo" name="nombreCompleto" value={nombreCompleto} onChange={handleOnChange} />
							</FloatingLabel>
						</Form.Group>

						<Form.Group className="mb-3">
							<FloatingLabel label={t("assignMOSCertification.lastName")}>
								<Form.Control type="text" placeholder="Ingresa los apellidos" name="apellidos" value={apellidos} onChange={handleOnChange} />
							</FloatingLabel>
						</Form.Group>

						{usuarioExterno ? (
							<Form.Group className="mb-3">
								<FloatingLabel label={t("assignMOSCertification.email")}>
									<Form.Control type="text" placeholder="Ingresa un correo electrónico" name="correoPersonaCertificacion" value={correoPersonaCertificacion} onChange={handleOnChange} />
								</FloatingLabel>
							</Form.Group>
						) : null}

						<Button hidden type="submit" ref={formButtonRef} />
					</Form>

					<Alert variant="outlined" severity="info">
						{t("assignMOSCertification.externalPerson")}
					</Alert>
				</DialogContent>

				<DialogActions>
					<Button variant="success" onClick={() => formButtonRef?.current.click()}>
						{t("assignMOSCertification.assignCertification")} {showLoader ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
					</Button>

					<Button variant="secondary" onClick={handleClose}>
						{t("Cancel")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default CertificacionesAdquiridas;
